export var wrapper = 'rounded-10 flex flex-col items-center px-4 py-4 sm:px-6 justify-between mt-2 bg-uiBg';
export var content = 'w-full flex flex-row justify-start items-center py-2';
//# sourceMappingURL=points-progress-card.styles.js.map